<template>
  <!-- Slider-->
  <section class="w-100 prlx1 p-2 text-light" style="min-height: 100px;">
    <section class=" col-12  mx-auto  row justify-content-between">
      <!--            <section class="col-12 col-md-5 pt-5">-->
      <!--                <section><span class="fas fa-phone span"></span><p class="d-inline" style="">09032313681</p></section>-->
      <!--                <section><span class="fas fa-envelope span"></span>webpisheh@gmail.com</section>-->
      <!--                <section><span class="fas fa-map-marker-alt span"></span>تهران نارمک ایت ثانی غربی پ 26</section>-->
      <!---->
      <!--            </section>-->
      <section class="col-6 col-md-4 pt-4 ">

        <img class="mt-5 mt-md-0" src="image/white.png" style="" width="150" alt="">
      </section>
      <section class="col-6 col-md-4">
        <img class="mt-2 mt-md-0 float-end" src="image/stu1.png" width="175" alt="">
      </section>

    </section>




  </section>
  <!-- End Slider-->
</template>

<script>
    export default {
        name: "TheSlider"
    }
</script>

<style scoped>

</style>